import "bootstrap-daterangepicker/daterangepicker.css";
import "bootstrap/dist/css/bootstrap.css";
import { Formik } from "formik";
import { isEqual } from "lodash";
import moment from "moment";
import React, { useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { YYYY_MM_DD_HH_MM_SS } from "../../../../utils/const";
import {
  customRangeReport,
  normalizeInputMobileNumber,
  stringToDateWithFormat
} from "../../../../utils/utils";
import { useClearingAccountReportUIContext } from "../ClearingAccountReportUIContext";

const initialValues = {
  transactionId: "",
  amount: "",
  transactionFees: "",
  totalAmount: "",
  senderId: "",
  senderFirstName: "",
  senderLastName: "",
  senderEmail: "",
  senderMobile: "",
  receiverId: "",
  receiverFirstName: "",
  receiverLastName: "",
  receiverEmail: "",
  receiverMobile: "",
  scTransactionId: "",
  scAddress: "",
  confirmationId: "",
  transactionType: "",
  transactionMode: "",
  transactionStatus: "",
  unityStatus: "",
  scTransactionType: "",
  confirmationDate: "",
  transactionDate: "today",
  dateFilterLabel: "Today",
  holdingAccountType: ""
};
export function ClearingAccountReportFilter({ myRef }) {
  const [historyFilter] = useState(initialValues);

  const clearingAccountReportUIContext = useClearingAccountReportUIContext();
  const clearingAccountReportUIProps = useMemo(() => {
    return {
      queryParams: clearingAccountReportUIContext.queryParams,
      setQueryParams: clearingAccountReportUIContext.setQueryParams
    };
  }, [clearingAccountReportUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(
      clearingAccountReportUIProps.queryParams,
      values
    );
    if (!isEqual(newQueryParams, clearingAccountReportUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      // update list by queryParams
      clearingAccountReportUIProps.setQueryParams(newQueryParams);
    }
  };

  const prepareFilter = (queryParams, values) => {
    const {
      transactionId,
      amount,
      transactionFees,
      totalAmount,
      senderId,
      senderFirstName,
      senderLastName,
      senderEmail,
      senderMobile,
      receiverId,
      receiverFirstName,
      receiverLastName,
      receiverEmail,
      receiverMobile,
      scTransactionId,
      scAddress,
      confirmationId,
      transactionType,
      transactionMode,
      transactionStatus,
      unityStatus,
      scTransactionType,
      confirmationDate,
      transactionDate,
      holdingAccountType,
      dateFrom,
      dateTo
    } = values;
    const newQueryParams = { ...queryParams };
    const filter = {};

    filter.transactionId = transactionId !== "" ? transactionId : undefined;
    filter.amount = amount !== "" ? amount : undefined;
    filter.transactionFees =
      transactionFees !== "" ? transactionFees : undefined;
    filter.totalAmount = totalAmount !== "" ? totalAmount : undefined;
    filter.senderId = senderId !== "" ? senderId : undefined;
    filter.senderFirstName =
      senderFirstName !== "" ? senderFirstName : undefined;
    filter.senderLastName = senderLastName !== "" ? senderLastName : undefined;

    filter.senderEmail = senderEmail !== "" ? senderEmail : undefined;
    filter.senderMobile = senderMobile !== "" ? senderMobile : undefined;
    filter.receiverId = receiverId !== "" ? receiverId : undefined;
    filter.receiverFirstName =
      receiverFirstName !== "" ? receiverFirstName : undefined;
    filter.receiverLastName =
      receiverLastName !== "" ? receiverLastName : undefined;
    filter.receiverEmail = receiverEmail !== "" ? receiverEmail : undefined;
    filter.receiverMobile = receiverMobile !== "" ? receiverMobile : undefined;

    filter.scTransactionId =
      scTransactionId !== "" ? scTransactionId : undefined;
    filter.scAddress = scAddress !== "" ? scAddress : undefined;
    filter.confirmationId = confirmationId !== "" ? confirmationId : undefined;
    filter.transactionType =
      transactionType !== "" ? transactionType : undefined;
    filter.transactionMode =
      transactionMode !== "" ? transactionMode : undefined;
    filter.transactionStatus =
      transactionStatus !== "" ? transactionStatus : undefined;
    filter.unityStatus = unityStatus !== "" ? unityStatus : undefined;

    filter.scTransactionType =
      scTransactionType !== "" ? scTransactionType : undefined;
    filter.confirmationDate =
      confirmationDate !== "" ? confirmationDate : undefined;
    filter.transactionDate =
      transactionDate !== "" ? transactionDate : undefined;
    filter.dateFrom = dateFrom !== "" ? dateFrom : undefined;
    filter.dateTo = dateTo !== "" ? dateTo : undefined;

    filter.holdingAccountType =
      holdingAccountType !== "" ? holdingAccountType : undefined;

    newQueryParams.filter = filter;
    return newQueryParams;
  };

  return (
    <>
      <Formik
        initialValues={historyFilter}
        onSubmit={(values) => {
          applyFilter(values);
        }}
        onReset={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
          handleReset
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchTransactionId"
                  placeholder="Transaction Id"
                  onBlur={handleBlur}
                  value={values.transactionId}
                  onChange={(e) => {
                    setFieldValue("transactionId", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Transaction ID</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="amount"
                  placeholder="Amount"
                  onBlur={handleBlur}
                  value={values.amount}
                  onChange={(e) => {
                    let value = e.target.value.replace(/-/g, "");
                    const regExp = new RegExp(/^\d*\.?\d*$/);
                    if (regExp.test(value)) {
                      setFieldValue("amount", value);
                      handleSubmit();
                    } else {
                      setFieldValue("amount", 0);
                    }
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Amount</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="transactionFees"
                  placeholder="Transaction Fee"
                  onBlur={handleBlur}
                  value={values.transactionFees}
                  onChange={(e) => {
                    let value = e.target.value.replace(/-/g, "");
                    const regExp = new RegExp(/^\d*\.?\d*$/);
                    if (regExp.test(value)) {
                      setFieldValue("transactionFees", value);
                      handleSubmit();
                    } else {
                      setFieldValue("transactionFees", 0);
                    }
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Transaction Fee</b>
                </small>
              </div>
              {/* <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="totalAmount"
                  placeholder="Total Amount"
                  onBlur={handleBlur}
                  value={values.totalAmount}
                  onChange={(e) => {
                    setFieldValue("totalAmount", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Total Amount</b>
                </small>
              </div> */}
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="senderId"
                  placeholder="Sender Id"
                  onBlur={handleBlur}
                  value={values.senderId}
                  onChange={(e) => {
                    setFieldValue("senderId", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Sender Id</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="senderFirstName"
                  placeholder="Sender Firstname"
                  onBlur={handleBlur}
                  value={values.senderFirstName}
                  onChange={(e) => {
                    setFieldValue("senderFirstName", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Sender Firstname</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="senderLastName"
                  placeholder="Sender Lastname"
                  onBlur={handleBlur}
                  value={values.senderLastName}
                  onChange={(e) => {
                    setFieldValue("senderLastName", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Sender Lastname</b>
                </small>
              </div>
            </div>

            <div className="form-group row">
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="senderEmail"
                  placeholder="Sender Email"
                  onBlur={handleBlur}
                  value={values.senderEmail}
                  onChange={(e) => {
                    setFieldValue("senderEmail", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Sender Email</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="senderMobile"
                  placeholder="Sender Mobile Number"
                  onBlur={handleBlur}
                  value={values.senderMobile}
                  onChange={(e) => {
                    const cellNumberWithFormat = normalizeInputMobileNumber(
                      e.target.value,
                      values.senderMobile
                    );
                    setFieldValue("senderMobile", cellNumberWithFormat);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Sender Mobile Number</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="receiverId"
                  placeholder="Receiver Id"
                  onBlur={handleBlur}
                  value={values.receiverId}
                  onChange={(e) => {
                    setFieldValue("receiverId", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Receiver Id</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="receiverFirstName"
                  placeholder="Receiver Firstname"
                  onBlur={handleBlur}
                  value={values.receiverFirstName}
                  onChange={(e) => {
                    setFieldValue("receiverFirstName", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Receiver Firstname</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="receiverLastName"
                  placeholder="Receiver Lastname"
                  onBlur={handleBlur}
                  value={values.receiverLastName}
                  onChange={(e) => {
                    setFieldValue("receiverLastName", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Receiver Lastname</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="receiverEmail"
                  placeholder="Receiver Email"
                  onBlur={handleBlur}
                  value={values.receiverEmail}
                  onChange={(e) => {
                    setFieldValue("receiverEmail", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Receiver Email</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="receiverMobile"
                  placeholder="Receiver Mobile"
                  onBlur={handleBlur}
                  value={values.receiverMobile}
                  onChange={(e) => {
                    const cellNumberWithFormat = normalizeInputMobileNumber(
                      e.target.value,
                      values.receiverMobile
                    );
                    setFieldValue("receiverMobile", cellNumberWithFormat);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Receiver Mobile</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="scTransactionId"
                  placeholder="SC Transaction Id"
                  onBlur={handleBlur}
                  value={values.scTransactionId}
                  onChange={(e) => {
                    setFieldValue("scTransactionId", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>SC Transaction Id</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="scAddress"
                  placeholder="SC Property Address"
                  onBlur={handleBlur}
                  value={values.scAddress}
                  onChange={(e) => {
                    setFieldValue("scAddress", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>SC Property Address</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="confirmationId"
                  placeholder="Confirmation ID"
                  onBlur={handleBlur}
                  value={values.confirmationId}
                  onChange={(e) => {
                    setFieldValue("confirmationId", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Confirmation ID</b>
                </small>
              </div>
            </div>

            <div className="form-group row">
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="transactionMode"
                  placeholder="Filter by Deposit Type"
                  onChange={(e) => {
                    setFieldValue("transactionMode", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.transactionMode}
                >
                  <option value="">All</option>
                  {/* <option value="1">eCheck</option> */}
                  <option value="2">ACH</option>
                  <option value="3">Credit Card</option>
                  {/* <option value="4">Wire Transfer</option> */}
                  {/* <option value="5">General</option> */}
                  <option value="6">Debit Card</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Deposit Type</b>
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="transactionStatus"
                  placeholder="Filter by Status Type"
                  onChange={(e) => {
                    setFieldValue("transactionStatus", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.transactionStatus}
                >
                  <option value="">All</option>
                  <option value="1">Pending</option>
                  <option value="2">Rejected</option>
                  <option value="3">Accepted</option>
                  <option value="4">Approved</option>
                  <option value="5">Cancelled</option>
                  <option value="6">Declined</option>
                  <option value="7">Failed</option>
                  <option value="8">Awaiting Processing</option>
                  <option value="9">Being Processed</option>
                  <option value="10">Hold</option>
                  <option value="11">Returned / Refunded</option>
                  <option value="12">Returned Ineligible</option>
                  <option value="13">Refund Processing</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Status</b>
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="unityStatus"
                  placeholder="Filter by Status Type"
                  onChange={(e) => {
                    setFieldValue("unityStatus", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.unityStatus}
                >
                  <option value="">All</option>
                  <option value="AwaitingProcessing">AwaitingProcessing</option>
                  <option value="BeingProcessed">BeingProcessed</option>
                  <option value="Completed">Completed</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Refunded">Refunded</option>
                  <option value="ProcessingReturn">ProcessingReturn </option>
                  <option value="ReturnedCollected">ReturnedCollected </option>
                  <option value="ReturnedIneligible">ReturnedIneligible</option>
                  <option value="ReturnedNotCollected">
                    ReturnedNotCollected
                  </option>
                  <option value="Declined">Declined </option>
                  <option value="Failed">Failed</option>
                  <option value="AwaitingAuthorization">
                    AwaitingAuthorization
                  </option>
                  <option value="Authorized">Authorized </option>
                  <option value="AuthorizationExpired">
                    AuthorizationExpired
                  </option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Unity Status</b>
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="scTransactionType"
                  placeholder="Filter by SC Type"
                  onChange={(e) => {
                    setFieldValue("scTransactionType", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.scTransactionType}
                >
                  <option value="">All</option>
                  <option value="Due Dilligence">Due Dilligence</option>
                  <option value="Earnest Money">Earnest Money</option>
                  <option value="Other">Other</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>SC Type</b>
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="holdingAccountType"
                  placeholder="Filter by Holding Account Type"
                  onChange={(e) => {
                    setFieldValue("holdingAccountType", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.holdingAccountType}
                >
                  <option value="">All</option>
                  <option value="1">Holding Account</option>
                  <option value="1">Revenue Account</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Holding Account Type</b>
                </small>
              </div>
              <div className="col-lg-2">
                <DateRangePicker
                  onApply={(event, picker) => {
                    const { chosenLabel } = picker || {};
                    const fromDate = picker.startDate._d.toISOString();
                    const endDate = picker.endDate._d.toISOString();
                    let label = chosenLabel;
                    if (label === "Today") {
                      label = "today";
                    }
                    if (label === "Yesterday ") {
                      label = "yesterday";
                    }
                    if (label === "Last 7 Days") {
                      label = "last7days";
                    }
                    if (label === "Last 30 Days") {
                      label = "last30days";
                    }
                    if (label === "This Week") {
                      label = "thisweek";
                    }
                    if (label === "This Month") {
                      label = "thismonth";
                    }
                    if (label === "This Year") {
                      label = "thisyear";
                    }
                    if (label === "Custom Range") {
                      label = "customrange";
                    }
                    const dateFrom = stringToDateWithFormat(fromDate);
                    const dateEnd = stringToDateWithFormat(endDate);
                    const dateFromMoment = moment(dateFrom).format(
                      YYYY_MM_DD_HH_MM_SS
                    );
                    const dateEndMoment = moment(dateEnd).format(
                      YYYY_MM_DD_HH_MM_SS
                    );
                    setFieldValue("transactionDate", label.toLowerCase());
                    setFieldValue("dateFilterLabel", chosenLabel);
                    setFieldValue("dateFrom", dateFromMoment);
                    setFieldValue("dateTo", dateEndMoment);
                    handleSubmit();
                  }}
                  initialSettings={{
                    startDate: moment().startOf("today"),
                    endDate: moment().endOf("today"),
                    ranges: customRangeReport,
                    opens: "left",
                    applyButtonClasses: "btn btn-brand"
                  }}
                >
                  <Button variant="btn btn-brand font-weight-bolder form-control">
                    <span className="svg-icon svg-icon-sm svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Calendar.svg"
                        )}
                      ></SVG>
                    </span>
                    {values.dateFilterLabel}
                  </Button>
                </DateRangePicker>
              </div>
              <div className="col-lg-2">
                <button
                  className="btn btn-white-primary"
                  onClick={handleReset}
                  ref={myRef}
                  style={{ display: "none" }}
                ></button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
